import { useHintPopover } from '@/hooks/useHintPopover';
import classNames from '@/utils/classNames';
import InfoCircleIcon from '@bloomberg/web-icons-react/InfoCircle';
import type { ReactNode } from 'react';
import { useId } from 'react';
import type { FCC } from 'react-fc';
import popoverStyles from './PopoverContent.module.css';
import styles from './Tooltip.module.css';

export interface TooltipProps {
    id?: string;
    trigger?: ReactNode;
}

export const Tooltip: FCC<TooltipProps> = ({ id, trigger, className, children }) => {
    const fallbackId = useId();
    const { popoverRef, openPopover, closePopover } = useHintPopover();

    const tooltipId = id ?? fallbackId;
    const triggerContent = trigger ?? <InfoCircleIcon aria-hidden />;

    return (
        <span className={classNames(styles.wrapper, popoverStyles.anchorScope, className)}>
            <button
                type="button"
                className={classNames(styles.trigger, popoverStyles.anchorTrigger)}
                aria-describedby={tooltipId}
                aria-label={trigger ? undefined : 'Show more information'}
                popoverTarget={tooltipId}
                popoverTargetAction="toggle"
                onMouseEnter={openPopover}
                onMouseLeave={closePopover}
            >
                {triggerContent}
            </button>

            <span id={tooltipId} ref={popoverRef} role="tooltip" popover="hint" className={popoverStyles.popover}>
                <span className={popoverStyles.popoverInner}>{children}</span>
            </span>
        </span>
    );
};
